import React, {useEffect, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {Accordion, Badge, Col, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import AccountingBox from "../../../primer/AccountingBox";
import {toast} from "react-toastify";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {
    checkPermissionMasterParentStartingTree, getCurrentUser,
    getDocumentLabel,
    getGreekCurrencyFormat,
    getOptionsByData, getSelectedPreNumbers,
    isEmpty, quickClone, truncateString
} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import {Popconfirm} from "antd";
import {TfiUnlink} from "react-icons/tfi";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {
    newAccountingRecordInitialValue,
    resetNewAccountingRecord, setAutoNewRecordData,
    setHookTransactionModalData, setNewAccountingRecord,
    setShowHookTransactionModal
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {
    openAccountingRecord, openBuy,
    openClientPayment, openSale,
    openSupplierPayment
} from "../../../../_helpers/tabOpeners";
import DeleteModal from "../../../primer/POPUP-COMPONENTS/Delete-Modal/deleteModal";
import {CiTrash} from "react-icons/ci";
import SalesNew from "../Sales/sales-new";
import {
    validateAccountingRecord,
    validateBuyObject,
    validateClientPayment,
    validateSaleObject, validateSupplierPayment
} from "../../../../_helpers/validator";
import {postAccountingRecord, postBuys, postClientPayment, postSales, postSupplierPayment} from "../../../../_apis/api";
import BuysNew from "../Buys/buys-new";
import {newSalesInitialValue, resetNewSales, setNewSales} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {newBuysInitialValue, resetNewBuys, setNewBuys} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import NewAccountingRecord from "../Accounting/new-accounting-record";
import Pagination from "../../../primer/Pagination";
import {
    newClientPaymentInitialValue,
    resetNewClientPayment, setAutoClientPaymentData,
    setNewClientPayment
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import {
    newSupplierPaymentInitialValue,
    resetNewSupplierPayment, setAutoSupplierPaymentData, setNewSupplierPayment
} from "../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import ClientPaymentsNew from "../Sales/client-payments-new";
import SupplierPaymentsNew from "../Buys/supplier-payments-new";
import Alert from "react-bootstrap/esm/Alert";
import AITrailViewer from "../AI/components/AITrailViewer";
import {LuFileJson} from "react-icons/lu";
import {PiPathFill} from "react-icons/pi";
import {RiGeminiFill} from "react-icons/ri";
import {TbReload} from "react-icons/tb";
import {MdOutlineCancel} from "react-icons/md";
import {resetNewLoan, setNewLoan} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import NewLoan from "../Cash/new-loan";
import AIDraftLine from "./components/AIDraftLine";
import DeleteDecorrelateModal from "./components/DeleteDecorrelateModal";

const HookTransactionModal = ({callback, upgraded = false, onAIRegister, onAIReprocess, onAIDecline}) => {
    // General Rule: Sales and Buys correlate their hooked payments and not themselves

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const show = useSelector((state) => state.ACCOUNTING_DATA.showHookTransactionModal);
    const setShow = (bool) => {
        if (section === "Sales") dispatch(resetNewSales());
        else if (section === "Buys") dispatch(resetNewBuys());
        else if (section === "Accounting Records") dispatch(resetNewAccountingRecord());
        else if (section === "Client Payments") dispatch(resetNewClientPayment());
        else if (section === "Supplier Payments") dispatch(resetNewSupplierPayment());

        setDraftDocumentIndex(0);
        dispatch(setShowHookTransactionModal(bool));
    }
    const hookTransactionModalData = useSelector((state) => state.ACCOUNTING_DATA.hookTransactionModalData);
    const transaction = hookTransactionModalData.transaction;
    const section = hookTransactionModalData.section;
    const setSection = (newSection) => {
        if (section === "Sales") dispatch(resetNewSales());
        else if (section === "Buys") dispatch(resetNewBuys());
        else if (section === "Accounting Records") dispatch(resetNewAccountingRecord());
        else if (section === "Client Payments") dispatch(resetNewClientPayment());
        else if (section === "Supplier Payments") dispatch(resetNewSupplierPayment());

        dispatch(setHookTransactionModalData({...hookTransactionModalData, section: newSection}));
        setLoadDefaults(true);
    }
    const updateAIDrafts = (newDrafts) => {
        dispatch(setHookTransactionModalData({...hookTransactionModalData, transaction: {...transaction, ai_drafts: newDrafts}}));
    }
    const documentHooks = hookTransactionModalData.documentHooks;
    const setDocumentHooks = (arr) => dispatch(setHookTransactionModalData({...hookTransactionModalData, documentHooks: arr}));

    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const ACCOUNTING_DATA = useSelector((state) => state.ACCOUNTING_DATA);
    const BUYS = useSelector((state) => state.BUYS);
    const SALES = useSelector((state) => state.SALES);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const BUYS_SETTINGS = useSelector((state) => state.BUYS_SETTINGS);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const newLoan = useSelector((state) => state.CASH_DATA.newLoan);
    const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
    const newClientPayment = useSelector((state) => state.CLIENTS_DATA.newClientPayment);
    const newSupplierPayment = useSelector((state) => state.SUPPLIERS_DATA.newSupplierPayment);
    const bankingSubCategories = useSelector((state) => state.ACCOUNTING_DATA.bankingSubCategories);
    const [correlatedEntitiesList, setCorrelatedEntitiesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [installationOptions, setInstallationOptions] = useState([]);

    const [showTrailModal, setShowTrailModal] = useState(false);
    const [showAIJsonResponse, setShowAIJsonResponse] = useState(false);
    const [showAIThoughts, setShowAIThoughts] = useState(false);
    const [showReprocess, setShowReprocess] = useState(false);
    const [showDecline, setShowDecline] = useState(false);

    const [doAutoSave, setAutoSave] = useState(false);

    const [showDeleteDecorrelateModal, setShowDeleteDecorrelateModal] = useState(false);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const ai_drafts = transaction?.ai_drafts || [];
    const multipleAIInvoices = ai_drafts.length > 1 && upgraded;
    const [draftDocumentIndex, setDraftDocumentIndex] = useState(0);

    const bankingSubCategoriesOptions = bankingSubCategories.map((o) => {
        return {
            label: o.title,
            value: o._id,
        }
    })

    const defaultHook = {
        type: "new", // new, correlate (new deprecated)
        documentId: "",
        section: section,
        label: "",
        correlatedEntity: "",
        correlatedEntityName: "",
        affects: "+",
        amount: 0,

        // For new ones
        installation: "0",
        documentType: "",
        preNumber: "",
        reason: "",
        date: moment().toDate(),
    }
    const [newHook, setNewHook] = useState({...defaultHook});
    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const clientPaymentsDT = getObjectFromArrayOfObjects(allDocumentTypes, section, "section");
    const documentTypesOptions = getOptionsByData(clientPaymentsDT, "_id", "name");
    const preNumberOptions = !isEmpty(newHook.documentType) ?
        getSelectedPreNumbers(allDocumentTypes.find((el) => el._id === newHook.documentType)?.documentNumbering, [null], newHook.installation)
        :
        [];

    const defaultHookAutoPayment = {
        date: moment().toDate(),
        documentType: "",
        preNumber: "",
    }
    const [newHookAutoPayment, setNewHookAutoPayment] = useState({...defaultHookAutoPayment}); // Used when section is Sales or Buys for payment generation
    const autoPaymentDocumentTypes = section === "Sales"
        ? getOptionsByData(getObjectFromArrayOfObjects(allDocumentTypes, "Client Payments", "section"), "_id", "name")
        : section === "Buys"
        ? getOptionsByData(getObjectFromArrayOfObjects(allDocumentTypes, "Supplier Payments", "section"), "_id", "name")
        : [];
    const autoPaymentPreNumbers = !isEmpty(newHookAutoPayment.documentType) ?
        (section === "Sales" ? getSelectedPreNumbers(allDocumentTypes.find((el) => el._id === newHookAutoPayment.documentType)?.documentNumbering, [null], SALES.newSales.installation)
        : section === "Buys" ? getSelectedPreNumbers(allDocumentTypes.find((el) => el._id === newHookAutoPayment.documentType)?.documentNumbering, [null], BUYS.newBuys.installation) : [])
        : [];

    // For correlation table
    const [pageChanged, setPageChanged] = useState(false);
    const [page, setPage] = useState(1);
    const [requestData, setRequestData] = useState({
        dateFrom: moment(String(company.year), "YYYY").startOf("year").format("DD/MM/YYYY"),
        dateTo: moment(String(company.year), "YYYY").endOf("year").format("DD/MM/YYYY"),
    })
    const [viewData, setViewData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [toBeDeleted, setToBeDeleted] = useState("");
    const [toBeDeletedSection, setToBeDeletedSection] = useState("");

    const currentSum = +Number(documentHooks?.reduce((sum, obj) => {
        if (obj.affects === "+") return sum + obj.amount;
        else if (obj.affects === "-") return sum - obj.amount;
        else return sum;
    }, 0)).toFixed(2);
    const maxSum = Math.abs(transaction?.transactionAmount || 0);

    const saleAutoCorrelation = useRef(null);
    const saleAutoCorrelationAmount = useRef(0);
    const buyAutoCorrelation = useRef(null);
    const buyAutoCorrelationAmount = useRef(0);

    const autoLoan = upgraded && newHook.subcategoryName === "Εκταμίευση Δανείου";
    const [availableNewLoan, setAvailableNewLoan] = useState(false);

    const sectionToTableName = {
        "Sales" : "Sales Search",
        "Buys": "Buys Search",
        "Accounting Records": "Accounting Record Search",
        "Client Payments" : "Client Payments Search",
        "Supplier Payments" : "Supplier Payments Search"
    }

    const getSectionOptions = () => {
        let options = [
            { value: "Client Payments", label: "Εισπράξεις" },
            { value: "Sales", label: "Πωλήσεις" },
        ];
        if (checkPermissionMasterParentStartingTree("buys", permissionsData)) {
            options.push({ value: "Supplier Payments", label: "Πληρωμές" });
            options.push({ value: "Buys", label: "Αγορές" });
        }
        if (checkPermissionMasterParentStartingTree("accounting", permissionsData)) {
            options.push({ value: "Accounting Records", label: "Λογιστικές Εγγ." });
        }
        if (upgraded) options = options.filter((el) => !["Sales", "Buys"].includes(el.value));

        return options;
    }

    // Client Payment watchdog for multiple invoices
    useEffect(() => {
        if (multipleAIInvoices) {
            const dIndex = ai_drafts.findIndex((el) => el.documentId === newClientPayment._id);
            if (dIndex >= 0) {
                const cloneDrafts = quickClone(ai_drafts);
                cloneDrafts[dIndex].ai_document = quickClone(newClientPayment);
                updateAIDrafts(cloneDrafts);
            }
        }
    }, [newClientPayment])

    useEffect(() => {
        if (multipleAIInvoices) {
            const dIndex = ai_drafts.findIndex((el) => el.documentId === newSupplierPayment._id);
            if (dIndex >= 0) {
                const cloneDrafts = quickClone(ai_drafts);
                cloneDrafts[dIndex].ai_document = quickClone(newSupplierPayment);
                updateAIDrafts(cloneDrafts);
            }
        }
    }, [newSupplierPayment])

    useEffect(() => {
        if (doAutoSave) {
            setAutoSave(false);
            onSave();
        }
    }, [doAutoSave]);

    useEffect(() => {
        if (autoLoan) {
            const d0 = ai_drafts[0] || null;
            if (d0 && d0?.autoLoan) {
                dispatch(setNewLoan(d0?.autoLoan))
                setAvailableNewLoan(true);
            }
        }
    }, [newHook.subcategoryName])

    const [loadDefaults, setLoadDefaults] = useState(false);
    const [firstDefaultLoad, setFirstDefaultLoad] = useState(false);
    useEffect(() => {
        if (loadDefaults) {
            setLoadDefaults(false);
            if (firstDefaultLoad) setFirstDefaultLoad(false);
            if (section === "Sales") {
                const prepSale = {...newSalesInitialValue};
                const ptObj = SALES_SETTINGS.salesGeneralSettings.paymentTypes.find((el) => el.type === "bank-account");
                const bankObj = bankAccounts.find((el) => el._id === transaction.bankAccount);
                if (ptObj) {
                    prepSale.paymentType = ptObj._id;
                    prepSale.paymentTypeName = ptObj.name;
                    prepSale.myDataPaymentId = ptObj.myDataPaymentId;
                }
                if (bankObj) {
                    prepSale.bankAccount = bankObj._id;
                    prepSale.bankAccountName = bankObj.name;
                }
                setNewHookAutoPayment({
                    ...newHookAutoPayment,
                    date: transaction["bookingDate"],
                    documentType: ptObj?.options?.documentType ? ptObj.options.documentType : "",
                    preNumber: ptObj?.options?.preNumber ? ptObj.options.preNumber : "",
                });
                dispatch(setNewSales(prepSale));
            } else if (section === "Buys") {
                const prepBuy = {...newBuysInitialValue};
                const ptObj = BUYS_SETTINGS.buysGeneralSettings.paymentTypes.find((el) => el.type === "bank-account");
                const bankObj = bankAccounts.find((el) => el._id === transaction.bankAccount);
                if (ptObj) {
                    prepBuy.paymentType = ptObj._id;
                    prepBuy.paymentTypeName = ptObj.name;
                    prepBuy.myDataPaymentId = ptObj.myDataPaymentId;
                }
                if (bankObj) {
                    prepBuy.bankAccount = bankObj._id;
                    prepBuy.bankAccountName = bankObj.name;
                }
                setNewHookAutoPayment({
                    ...newHookAutoPayment,
                    date: transaction["bookingDate"],
                    documentType: ptObj?.options?.documentType ? ptObj.options.documentType : "",
                    preNumber: ptObj?.options?.preNumber ? ptObj.options.preNumber : "",
                });
                dispatch(setNewBuys(prepBuy));
            } else if (section === "Accounting Records") {
                const prepRecord = {...newAccountingRecordInitialValue};
                const ptObj = ACCOUNTING_DATA.paymentTypes.find((el) => el.type === "bank-account");
                const bankObj = bankAccounts.find((el) => el._id === transaction.bankAccount);
                if (ptObj) {
                    prepRecord.paymentType = ptObj._id;
                    prepRecord.paymentTypeName = ptObj.name;
                    prepRecord.myDataPaymentId = ptObj.myDataPaymentId;
                }
                if (bankObj) {
                    prepRecord.bankAccount = bankObj._id;
                    prepRecord.bankAccountName = bankObj.name;
                }
                prepRecord.date = moment(transaction["bookingDate"]).toDate();
                prepRecord.reason = String(transaction["erp_description"]).trim();
                dispatch(setNewAccountingRecord(prepRecord));
                if (upgraded) {
                    if (transaction?.ai_status === 500 && firstDefaultLoad && ai_drafts[draftDocumentIndex]) { // Pre-fill AI document
                        const aiDoc = ai_drafts[draftDocumentIndex].ai_document;
                        const subCategory = bankingSubCategories.find((el) => el._id === ai_drafts[draftDocumentIndex].documentSubCategory);
                        if (aiDoc && subCategory) {
                            setNewHook({
                                ...newHook,
                                subcategoryId: subCategory._id,
                                subcategoryName: subCategory.title,
                            });
                            dispatch(setNewAccountingRecord(aiDoc));
                        }
                    } else {
                        const subCategory = bankingSubCategories.find((el) => el._id === newHook.subcategoryId);
                        if (subCategory && subCategory.accountingCategory && subCategory.accountingSubCategory) {
                            dispatch(setAutoNewRecordData({
                                category: subCategory.accountingCategory,
                                subCategory: subCategory.accountingSubCategory,
                                documentType: subCategory.documentType,
                                transactionAmount: transaction.transactionAmount,
                                bankAccount: bankAccounts.find((el) => el._id === transaction.bankAccount),
                                accounts: (subCategory?.accounts || []).map((acc) => {
                                    return {
                                        code: acc.code,
                                        type: acc.type,
                                    }
                                }),
                            }))
                        }
                    }
                }
            } else if (section === "Client Payments") {
                const prepClientPayment = {...newClientPaymentInitialValue};
                const ptObj = SALES_SETTINGS.salesGeneralSettings.paymentTypes.find((el) => el.type === "bank-account");
                const bankObj = bankAccounts.find((el) => el._id === transaction.bankAccount);
                if (ptObj) {
                    prepClientPayment.paymentType = ptObj._id;
                    prepClientPayment.paymentTypeName = ptObj.name;
                    prepClientPayment.paymentTypeType = "bank-account";
                }
                const amount = saleAutoCorrelationAmount.current > 0 ? saleAutoCorrelationAmount.current : maxSum;
                if (bankObj) {
                    prepClientPayment.bankAccount = bankObj._id;
                    prepClientPayment.bankAccountName = bankObj.name;
                    prepClientPayment.amount = amount;
                    prepClientPayment.bankAmount = amount;
                    prepClientPayment.bankDetails = [{
                        no: "1",
                        id: "1",
                        name: bankObj.name,
                        accountNumber: bankObj.iban,
                        amount: amount,
                        notes: "",
                        _id: bankObj._id
                    }]
                }
                if (saleAutoCorrelation.current) {
                    prepClientPayment.client = saleAutoCorrelation.current.client;
                    prepClientPayment.clientName = saleAutoCorrelation.current.clientName;
                    prepClientPayment.vatNumber = saleAutoCorrelation.current.vat;
                    prepClientPayment.address = saleAutoCorrelation.current.address;
                    prepClientPayment.country = saleAutoCorrelation.current.country;
                    prepClientPayment.phone = saleAutoCorrelation.current.phone;
                    prepClientPayment.email = saleAutoCorrelation.current.email;
                    prepClientPayment.forSale = saleAutoCorrelation.current._id;
                    prepClientPayment.forSaleInputLabel = getDocumentLabel(saleAutoCorrelation.current);

                    saleAutoCorrelation.current = null;
                    saleAutoCorrelationAmount.current = 0;
                }
                prepClientPayment.reason = String(transaction["erp_description"]).trim();
                prepClientPayment.date = moment(transaction["bookingDate"]).toDate();
                dispatch(setNewClientPayment(prepClientPayment));
                if (upgraded) {
                    if (transaction?.ai_status === 500 && firstDefaultLoad && ai_drafts[draftDocumentIndex]) { // Pre-fill AI document
                        const aiDoc = ai_drafts[draftDocumentIndex].ai_document;
                        const subCategory = bankingSubCategories.find((el) => el._id === ai_drafts[draftDocumentIndex].documentSubCategory);
                        if (aiDoc && subCategory) {
                            setNewHook({
                                ...newHook,
                                subcategoryId: subCategory._id,
                                subcategoryName: subCategory.title,
                            });
                            dispatch(setNewClientPayment(aiDoc));
                        }
                    } else {
                        const subCategory = bankingSubCategories.find((el) => el._id === newHook.subcategoryId);
                        if (subCategory && subCategory.documentType) {
                            dispatch(setAutoClientPaymentData({
                                documentType: subCategory.documentType,
                            }))
                        }
                    }
                }
            } else if (section === "Supplier Payments") {
                const prepSupplierPayment = {...newSupplierPaymentInitialValue};
                const ptObj = BUYS_SETTINGS.buysGeneralSettings.paymentTypes.find((el) => el.type === "bank-account");
                const bankObj = bankAccounts.find((el) => el._id === transaction.bankAccount);
                if (ptObj) {
                    prepSupplierPayment.paymentType = ptObj._id;
                    prepSupplierPayment.paymentTypeName = ptObj.name;
                    prepSupplierPayment.paymentTypeType = "bank-account";
                }
                const amount = saleAutoCorrelationAmount.current > 0 ? saleAutoCorrelationAmount.current : maxSum;
                if (bankObj) {
                    prepSupplierPayment.bankAccount = bankObj._id;
                    prepSupplierPayment.bankAccountName = bankObj.name;
                    prepSupplierPayment.amount = amount;
                    prepSupplierPayment.bankAmount = amount;
                    prepSupplierPayment.bankDetails = [{
                        no: "1",
                        id: "1",
                        name: bankObj.name,
                        accountNumber: bankObj.iban,
                        amount: amount,
                        notes: "",
                        _id: bankObj._id
                    }]
                }
                if (buyAutoCorrelation.current) {
                    prepSupplierPayment.supplier = buyAutoCorrelation.current.supplier;
                    prepSupplierPayment.supplierName = buyAutoCorrelation.current.supplierName;
                    prepSupplierPayment.vatNumber = buyAutoCorrelation.current.vat;
                    prepSupplierPayment.address = buyAutoCorrelation.current.address;
                    prepSupplierPayment.country = buyAutoCorrelation.current.country;
                    prepSupplierPayment.phone = buyAutoCorrelation.current.phone;
                    prepSupplierPayment.email = buyAutoCorrelation.current.email;
                    prepSupplierPayment.forBuy = buyAutoCorrelation.current._id;
                    prepSupplierPayment.forBuyInputLabel = getDocumentLabel(buyAutoCorrelation.current);

                    buyAutoCorrelation.current = null;
                    buyAutoCorrelationAmount.current = 0;
                }
                prepSupplierPayment.reason = String(transaction["erp_description"]).trim();
                prepSupplierPayment.date = moment(transaction["bookingDate"]).toDate();
                dispatch(setNewSupplierPayment(prepSupplierPayment));
                if (upgraded) {
                    if (transaction?.ai_status === 500 && firstDefaultLoad && ai_drafts[draftDocumentIndex]) { // Pre-fill AI document
                        const aiDoc = ai_drafts[draftDocumentIndex].ai_document;
                        const subCategory = bankingSubCategories.find((el) => el._id === ai_drafts[draftDocumentIndex].documentSubCategory);
                        if (aiDoc && subCategory) {
                            setNewHook({
                                ...newHook,
                                subcategoryId: subCategory._id,
                                subcategoryName: subCategory.title,
                            })
                            dispatch(setNewSupplierPayment(aiDoc));
                        }
                    } else {
                        const subCategory = bankingSubCategories.find((el) => el._id === newHook.subcategoryId);
                        if (subCategory && subCategory.documentType) {
                            dispatch(setAutoSupplierPaymentData({
                                documentType: subCategory.documentType,
                            }))
                        }
                    }
                }
            }
        }
    }, [loadDefaults])

    useEffect(() => {
        if (show) {
            setRequestData({
                dateFrom: moment(transaction["bookingDate"]).subtract(15, "day").format("DD/MM/YYYY"),
                dateTo: moment(transaction["bookingDate"]).add(15, "day").format("DD/MM/YYYY"),
            })
            setPage(1);
            setViewData([]);
            setTotalPages(0);
            setNewHook({
                ...newHook,
                date: transaction["bookingDate"],
                section: section,
                amount: maxSum,
            });
            setLoadDefaults(true);
            setFirstDefaultLoad(true);
        } else {
            setNewHook({...defaultHook});
            setNewHookAutoPayment({...newHookAutoPayment});
            if (availableNewLoan) {
                dispatch(resetNewLoan());
                setAvailableNewLoan(false);
            }
        }
    }, [show])

    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            companyInstallations.forEach((inst) => {
                options.push({ value: inst.installationMasterId, label: inst.type + " " + inst.address + " " + inst.city });
            })
            setInstallationOptions(options);
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchViewData(true);
        }
    }, [pageChanged])

    const loadCorrelatedEntitiesList = (keyword, setData) => {
        let endpoint = "";
        if (section === "Client Payments") endpoint = "/client/list-client";
        if (section === "Supplier Payments") endpoint = "/supplier/list-supplier";

        if (endpoint) {
            const reqData = { company: company.id }
            if (keyword) reqData.name = keyword;

            axios.post(`${process.env.REACT_APP_API_URL2}${endpoint}`, reqData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data && res.data.status === "200") {
                    if (res.data.data) setData(res.data.data);
                    else setData([]);
                } else {
                    setData([]);
                }
            }).catch((e) => {
                console.log(e);
            })
        }
    }

    const hookOptions = [
        { label: "Νέα εγγραφή", value: "new" },
        { label: "Συσχέτιση εγγραφής", value: "correlate" },
    ]

    const onSave = () => {
        // Quick validations
        if (currentSum > maxSum) return toast.error("Το συνολικό ποσό των εγγραφών ξεπερνάει το ποσό της συναλλαγής.");

        // Post
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/document-hook-transaction`, {
            company: company.id,
            documentHooks: documentHooks,
            transactionId: transaction._id,
            autoLoan: autoLoan ? newLoan : null,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                setShow(false);
                callback();
                if (autoLoan) dispatch(resetNewLoan());
                toast.success("Επιτυχής εγγραφή συναλλαγής.");
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onMultipleAISave = async () => {
        setLoading(true);
        onAIRegister(transaction, ai_drafts);
        setShow(false);
        setLoading(false);
    }

    const onHookSave = async (autoSave = false) => {
        if (newHook.type === "new") {
            if (section === "Sales") {
                if (isEmpty(newHookAutoPayment.documentType)) return toast.warning("Παρακαλώ συμπληρώστε γενικό παραστατικό είσπραξης.");
                if (isEmpty(newHookAutoPayment.preNumber)) return toast.warning("Παρακαλώ συμπληρώστε σειρά είσπραξης.");
                if (isEmpty(newHookAutoPayment.date)) return toast.warning("Παρακαλώ συμπληρώστε ημερομηνία είσπραξης.");

                const validationResponse = await validateSaleObject(SALES.newSales, company, SETTINGS, SALES_SETTINGS);
                if (!validationResponse.success) return toast.warning(validationResponse.message);

                const dataCallback = async (saleData) => {
                    if (saleData?.linkedClientPayments?.length > 0) {
                        const cpArr = [];
                        for (const lcp of saleData.linkedClientPayments) {
                            try {
                                const cpResp = await axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
                                    headers: { "Content-Type": "application/json" },
                                    params: {
                                        company: company.id,
                                        docId: lcp.clientPaymentId,
                                        section: "Client Payments",
                                    }
                                });
                                if (cpResp.data.status === "200") cpArr.push(cpResp.data.data);
                            } catch (axiosError) {
                                console.log(axiosError);
                                toast.error("Σφάλμα κατά την συσχέτιση είσπραξης.");
                            }
                        }
                        handleSelectMany(cpArr);
                    }
                    setLoadDefaults(true);
                }
                dispatch(postSales({...SALES.newSales, company: company.id, year: company.year, isActive: "active", autoPayment: newHookAutoPayment },
                    company.id, null, false, false, setLoading, SETTINGS.settings.advancedTypesSales,
                    false, false, false, TABS_DATA, dataCallback));
            } else if (section === "Buys") {
                const validationResponse = validateBuyObject(BUYS.newBuys, company, SETTINGS, BUYS_SETTINGS);
                if (!validationResponse.success) return toast.warning(validationResponse.message);

                const dataCallback = async (buysData) => {
                    if (buysData?.linkedSupplierPayments?.length > 0) {
                        const cpArr = [];
                        for (const lcp of buysData.linkedSupplierPayments) {
                            try {
                                const cpResp = await axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
                                    headers: { "Content-Type": "application/json" },
                                    params: {
                                        company: company.id,
                                        docId: lcp.supplierPaymentId,
                                        section: "Supplier Payments",
                                    }
                                });
                                if (cpResp.data.status === "200") cpArr.push(cpResp.data.data);
                            } catch (axiosError) {
                                console.log(axiosError);
                                toast.error("Σφάλμα κατά την συσχέτιση πληρωμής.");
                            }
                        }
                        handleSelectMany(cpArr);
                    }
                    setLoadDefaults(true);
                }
                dispatch(postBuys({...BUYS.newBuys, company: company.id, year: company.year, isActive: "active"}, { company: company.id },
                    null, false, setLoading, SETTINGS.settings.advancedTypesBuys, null, false, dataCallback))
            } else if (section === "Accounting Records") {
                if (upgraded && isEmpty(newHook.subcategoryId)) return toast.warning("Παρακαλώ επιλέξτε υποκατηγορία τραπεζικής εγγραφής.");
                const validationResponse = validateAccountingRecord(ACCOUNTING_DATA.newAccountingRecord, company);
                if (!validationResponse.success) return toast.warning(validationResponse.message);

                const dataCallback = (recordData) => {
                    if (upgraded) handleSelect({...recordData, subcategoryId: newHook.subcategoryId, subcategoryName: newHook.subcategoryName});
                    else handleSelect(recordData);

                    setLoadDefaults(true);
                    if (autoSave) setAutoSave(true);
                }
                dispatch(postAccountingRecord({...ACCOUNTING_DATA.newAccountingRecord, company: company.id, year: company.year, isActive: "active"}, { company: company.id },
                    setLoading, "save", false, dataCallback));
            } else if (section === "Client Payments") {
                if (upgraded && isEmpty(newHook.subcategoryId)) return toast.warning("Παρακαλώ επιλέξτε υποκατηγορία τραπεζικής εγγραφής.");
                const validationResponse = validateClientPayment(newClientPayment, company);
                if (!validationResponse.success) return toast.warning(validationResponse.message);

                const dataCallback = (cpData) => {
                    if (upgraded) handleSelect({...cpData, subcategoryId: newHook.subcategoryId, subcategoryName: newHook.subcategoryName});
                    else handleSelect(cpData);

                    setLoadDefaults(true);
                    if (autoSave) setAutoSave(true);
                }
                dispatch(postClientPayment({...newClientPayment, company: company.id, year: company.year, isActive: "active", fromBanking: true}, { company: company.id },
                    setLoading, null, false, false, false, null, false, false, dataCallback));
            } else if (section === "Supplier Payments") {
                if (upgraded && isEmpty(newHook.subcategoryId)) return toast.warning("Παρακαλώ επιλέξτε υποκατηγορία τραπεζικής εγγραφής.");
                const validationResponse = validateSupplierPayment(newSupplierPayment, company);
                if (!validationResponse.success) return toast.warning(validationResponse.message);

                const dataCallback = (spData) => {
                    if (upgraded) handleSelect({...spData, subcategoryId: newHook.subcategoryId, subcategoryName: newHook.subcategoryName});
                    else handleSelect(spData);

                    setLoadDefaults(true);
                    if (autoSave) setAutoSave(true);
                }
                dispatch(postSupplierPayment({...newSupplierPayment, company: company.id, year: company.year, isActive: "active", fromBanking: true}, { company: company.id },
                    setLoading, false, false, dataCallback))
            }
        }
    }

    const fetchViewData = (fromPagination = true) => {
        const toReq = {
            company: company.id,
            year: company.year,
            section: section,
            page: page,
            perPage: 10,
            fullObject: true,
            fromBanking: true,
            ...requestData,
        }
        if (!fromPagination) {
            setPage(1);
            toReq.page = 1;
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/cloud/fetch-doc-cor`, {
            headers: { "Content-Type": "application/json" },
            params: toReq
        }).then((res) => {
            if (res.data.status === "200") {
                setViewData(res.data.data);
                setTotalPages(res.data.totalPages);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const isSelected = (docId, forcedSection = null) => {
        if (forcedSection) {
            return documentHooks.some((el) => el.documentId === docId && el.section === forcedSection);
        } else {
            return documentHooks.some((el) => el.documentId === docId && el.section === section);
        }
    }
    
    const getDefaultAffection = (doc) => {
        // PROBLEM: Correlate Client Payment to transaction with negative amount while it is not money return
        // PROBLEM: Correlate Supplier Payment to transaction with positive amount while it is not money return

        const tAmount = +transaction.transactionAmount;
        if ((section === "Client Payments" && tAmount < 0 && doc.affects_client === "-") || (section === "Supplier Payments" && tAmount > 0 && doc.affects_supplier === "+")) return "-";
        return "+";
    }

    const handleSelect = async (row, forceAmount = 0) => {
        const defaultAffection = getDefaultAffection(row);
        if (section === "Sales") {
            try {
                const cpResp = await axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
                    headers: {"Content-Type": "application/json"},
                    params: {
                        company: company.id,
                        docId: row.clientPaymentId,
                        section: "Client Payments",
                    }
                });
                if (cpResp.data.status === "200") {
                    const docData = cpResp.data.data;
                    setDocumentHooks([...documentHooks, {
                        type: "correlate",
                        documentId: row.clientPaymentId,
                        section: "Client Payments",
                        label: getDocumentLabel(docData),
                        correlatedEntity: docData.client,
                        correlatedEntityName: docData.clientName,
                        amount: forceAmount > 0 ? forceAmount : (+docData["amount"] || 0),
                        affects: defaultAffection,
                    }]);
                }
            } catch (axiosError) {
                console.log(axiosError);
                toast.error("Σφάλμα κατά την συσχέτιση πληρωμής.");
            }
        } else if (section === "Buys") {
            try {
                const cpResp = await axios.get(`${process.env.REACT_APP_API_URL2}/company/get-document-by-id`, {
                    headers: {"Content-Type": "application/json"},
                    params: {
                        company: company.id,
                        docId: row.supplierPaymentId,
                        section: "Supplier Payments",
                    }
                });
                if (cpResp.data.status === "200") {
                    const docData = cpResp.data.data;
                    setDocumentHooks([...documentHooks, {
                        type: "correlate",
                        documentId: row.supplierPaymentId,
                        section: "Supplier Payments",
                        label: getDocumentLabel(docData),
                        correlatedEntity: docData.supplier,
                        correlatedEntityName: docData.supplierName,
                        amount: forceAmount > 0 ? forceAmount : (+docData["amount"] || 0),
                        affects: defaultAffection,
                    }]);
                }
            } catch (axiosError) {
                console.log(axiosError);
                toast.error("Σφάλμα κατά την συσχέτιση πληρωμής.");
            }
        } else if (section === "Accounting Records") {
            let correlatedEntity, correlatedEntityName;
            const acc = row.accounts.find((el) => el.subAccountType === "employee");
            if (acc) {
                correlatedEntity = acc.subAccountId;
                correlatedEntityName = acc.subAccount;
            }
            setDocumentHooks([...documentHooks, {
                type: "correlate",
                documentId: row._id,
                section: section,
                label: getDocumentLabel(row),
                correlatedEntity: correlatedEntity || undefined,
                correlatedEntityName: correlatedEntityName || undefined,
                amount: +row["totalDebit"] || 0,
                affects: defaultAffection,
                subcategoryId: row.subcategoryId,
                subcategoryName: row.subcategoryName,
            }]);
        } else if (section === "Client Payments") {
            setDocumentHooks([...documentHooks, {
                type: "correlate",
                documentId: row._id,
                section: section,
                label: getDocumentLabel(row),
                correlatedEntity: row.client,
                correlatedEntityName: row.clientName,
                amount: +row["amount"] || 0,
                affects: defaultAffection,
                subcategoryId: row.subcategoryId,
                subcategoryName: row.subcategoryName,
            }]);
        } else if (section === "Supplier Payments") {
            setDocumentHooks([...documentHooks, {
                type: "correlate",
                documentId: row._id,
                section: section,
                label: getDocumentLabel(row),
                correlatedEntity: row.supplier,
                correlatedEntityName: row.supplierName,
                amount: +row["amount"] || 0,
                affects: defaultAffection,
                subcategoryId: row.subcategoryId,
                subcategoryName: row.subcategoryName,
            }]);
        }
    }

    const handleSelectMany = (rows) => {
        const hooks = [];
        if (section === "Sales") {
            for (const row of rows) {
                const defaultAffection = getDefaultAffection(row);
                hooks.push({
                    type: "correlate",
                    documentId: row._id,
                    section: "Client Payments",
                    label: getDocumentLabel(row),
                    correlatedEntity: row.client,
                    correlatedEntityName: row.clientName,
                    amount: +row["amount"] || 0,
                    affects: defaultAffection,
                })
            }
        } else if (section === "Buys") {
            for (const row of rows) {
                const defaultAffection = getDefaultAffection(row);
                hooks.push({
                    type: "correlate",
                    documentId: row._id,
                    section: "Supplier Payments",
                    label: getDocumentLabel(row),
                    correlatedEntity: row.supplier,
                    correlatedEntityName: row.supplierName,
                    amount: +row["amount"] || 0,
                    affects: defaultAffection,
                })
            }
        }
        setDocumentHooks([...documentHooks, ...hooks]);
    }

    const handleDeselect = (documentId) => setDocumentHooks(documentHooks.filter((el) => el.documentId !== documentId));

    const handleOpenCorrelated = (documentId, section) => {
        if (section === "Client Payments") {
            openClientPayment(dispatch, TABS_DATA, company.id, documentId);
        } else if (section === "Supplier Payments") {
            if (checkPermissionMasterParentStartingTree("buys", permissionsData)) openSupplierPayment(dispatch, TABS_DATA, company.id, documentId);
        } else if (section === "Accounting Records") {
            if (checkPermissionMasterParentStartingTree("accounting", permissionsData)) openAccountingRecord(dispatch, TABS_DATA, company.id, documentId);
        }
    }

    const getEntity = (row) => {
        if (["Sales", "Client Payments"].includes(section)) {
            return row["clientName"];
        } else if (["Buys", "Supplier Payments"].includes(section)) {
            return row["supplierName"];
        } else if (section === "Accounting Records") {
            return row["accounts"]?.length > 0 ? truncateString(row["accounts"].flatMap((o) => o.subAccount).filter(Boolean).join(", ")) : "-";
        }
        return "-";
    }

    const sectionTitle = (str) => {
        if (str === "Sales") return "Πωλήσεις";
        else if (str === "Buys") return "Αγορές";
        else if (str === "Client Payments") return "Εισπράξεις";
        else if (str === "Supplier Payments") return "Πληρωμές";
        else if (str === "Accounting Records") return "Λογιστικές Εγγραφές";
        return str;
    }

    const handlePageChange = (pageNum) => {
        setPage(pageNum);
        setPageChanged(true);
    }

    const correlationDivStyle = {
        width: "100%",
        borderRadius: "8px",
        border: "2px solid lightgray",
        padding: "2px",
        fontSize: "12px",
        margin: "2px",
    }

    const renderSelectionTD = (row) => {
        if (section === "Sales") {
            const componentArr = [];
            let totalPaid = 0;
            if (row?.linkedClientPayments?.length > 0) {
                let idx = 0;
                for (const lcp of row.linkedClientPayments) {
                    totalPaid += (+lcp.amount || 0);
                    if (isSelected(lcp.clientPaymentId, "Client Payments")) {
                        componentArr.push(
                            <div style={correlationDivStyle}>
                                <span className={"mr-2"}>{lcp.displayString} : {getGreekCurrencyFormat(lcp.amount)}</span>
                                <Badge bg={"dark"} className={idx + 1 !== row.linkedClientPayments.length ? "mb-1" : ""} style={{cursor: "pointer"}} onClick={() => handleDeselect(lcp.clientPaymentId)}>Αποεπιλογή</Badge>
                            </div>
                        )
                    } else {
                        componentArr.push(
                            <div style={correlationDivStyle}>
                                <span className={"mr-2"}>{lcp.displayString} : {getGreekCurrencyFormat(lcp.amount)}</span>
                                <Badge bg={"primary"} className={idx + 1 !== row.linkedClientPayments.length ? "mb-1" : ""} style={{cursor: "pointer"}} onClick={() => handleSelect(lcp, +lcp.amount)}>Επιλογή</Badge>
                            </div>
                        )
                    }
                    idx++;
                }
            }
            const remaining = +Number(+row.paymentAmount - totalPaid).toFixed(2);
            if (remaining > 0) {
                const clickRemaining = () => {
                    saleAutoCorrelation.current = row;
                    saleAutoCorrelationAmount.current = remaining;
                    setSection("Client Payments");
                    setNewHook({...newHook, type: "new"});
                }
                componentArr.push(
                    <Badge bg={"info"} style={{cursor: "pointer", userSelect: "none"}} onClick={clickRemaining}>Δημιουργία είσπραξης</Badge>
                )
            }
            return componentArr;
        } else if (section === "Buys") {
            const componentArr = [];
            let totalPaid = 0;
            if (row?.linkedSupplierPayments?.length > 0) {
                let idx = 0;
                for (const lcp of row.linkedSupplierPayments) {
                    totalPaid += (+lcp.amount || 0);
                    if (isSelected(lcp.supplierPaymentId, "Supplier Payments")) {
                        componentArr.push(
                            <div style={correlationDivStyle}>
                                <span className={"mr-2"}>{lcp.displayString} : {getGreekCurrencyFormat(lcp.amount)}</span>
                                <Badge bg={"dark"} className={idx + 1 !== row.linkedSupplierPayments.length ? "mb-1" : ""} style={{cursor: "pointer"}} onClick={() => handleDeselect(lcp.supplierPaymentId)}>Αποεπιλογή</Badge>
                            </div>
                        )
                    } else {
                        componentArr.push(
                            <div style={correlationDivStyle}>
                                <span className={"mr-2"}>{lcp.displayString} : {getGreekCurrencyFormat(lcp.amount)}</span>
                                <Badge bg={"primary"} className={idx + 1 !== row.linkedSupplierPayments.length ? "mb-1" : ""} style={{cursor: "pointer"}} onClick={() => handleSelect(lcp, +lcp.amount)}>Επιλογή</Badge>
                            </div>
                        )
                    }
                    idx++;
                }
            }
            const remaining = +Number(+row.paymentAmount - totalPaid).toFixed(2);
            if (remaining > 0) {
                const clickRemaining = () => {
                    buyAutoCorrelation.current = row;
                    buyAutoCorrelationAmount.current = remaining;
                    setSection("Supplier Payments");
                    setNewHook({...newHook, type: "new"});
                }
                componentArr.push(
                    <Badge bg={"info"} style={{cursor: "pointer", userSelect: "none"}} onClick={clickRemaining}>Δημιουργία πληρωμής</Badge>
                )
            }
            return componentArr;
        } else {
            if (isSelected(row._id)) {
                return <Badge bg={"dark"} style={{cursor: "pointer"}} onClick={() => handleDeselect(row._id)}>Αποεπιλογή</Badge>;
            } else {
                return (
                    <React.Fragment>
                        <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => handleSelect(row)}>Επιλογή</Badge>
                        <Badge bg={"danger"} className={"ml-2"} style={{cursor: "pointer"}} onClick={() => {
                            setToBeDeleted(row._id);
                            setToBeDeletedSection(section);
                            setShowDeleteModal(true);
                        }}>Διαγραφή</Badge>
                    </React.Fragment>
                )
            }
        }
    }

    const getAISelectedEntity = () => {
        let ent = "";
        if (transaction && ai_drafts[draftDocumentIndex]) {
            const obj0 = ai_drafts[draftDocumentIndex];
            if (obj0 && obj0.ai_document) {
                if (obj0.documentSection === "Client Payments") ent = obj0.ai_document.clientName;
                else if (obj0.documentSection === "Supplier Payments") ent = obj0.ai_document.supplierName;
                else if (obj0.documentSection === "Accounting Records") {
                    const entAccount = obj0.ai_document.accounts.find((el) => ["client", "supplier", "employee"].includes(el.subAccountType));
                    if (entAccount) ent = entAccount.subAccount;
                }
            }
        }
        return ent;
    }

    const renderBestDocumentAlert = () => {
        if (upgraded) {
            if (ai_drafts[draftDocumentIndex]) {
                const obj0 = ai_drafts[draftDocumentIndex];
                if (obj0.bestDocumentLabel) {
                    const handleClick = () => {
                        if (obj0.bestDocumentSection === "Sales") openSale(dispatch, TABS_DATA, company.id, obj0.bestDocumentId);
                        else if (obj0.bestDocumentSection === "Buys") openBuy(dispatch, TABS_DATA, company.id, obj0.bestDocumentId);
                        else if (obj0.bestDocumentSection === "Accounting Records") openAccountingRecord(dispatch, TABS_DATA, company.id, obj0.bestDocumentId);
                    }
                    return (
                        <Col md={3}>
                            <Alert variant={"secondary"}>
                                Η εντοπισμένη συσχετιζόμενη εγγραφή είναι η:
                                <div style={{textDecoration: "underline", textDecorationStyle: "dotted", fontWeight: "600", cursor: "pointer"}} onClick={() => handleClick()}>
                                    {obj0.bestDocumentLabel}
                                </div>
                                με οντότητα <strong>{getAISelectedEntity()}</strong>
                            </Alert>
                        </Col>
                    )
                }
            }
        }
        return <React.Fragment></React.Fragment>
    }

    const onAIDraftChange = (draftDocument, idx) => {
        setDraftDocumentIndex(idx);
        setLoadDefaults(true);
        setFirstDefaultLoad(true);
    }

    const renderAIActionButtons = () => {
        return (
            <React.Fragment>
                <Button variant={"outline-danger"} onClick={() => setShowDecline(true)}><MdOutlineCancel className={"mr-1"} size={18} /> Απόρριψη</Button>
                <Button className={"ml-1"} onClick={() => setShowReprocess(true)}><TbReload className={"mr-1"} size={18}/>Επανεπεξεργασία</Button>
            </React.Fragment>
        )
    }

    const refreshTransaction = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/transaction`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
                transactionId: transaction._id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setHookTransactionModalData({
                    ...hookTransactionModalData,
                    transaction: res.data.data,
                    documentHooks: res.data.data.documentHooks,
                }));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Εγγραφή Συναλλαγής ({sectionTitle(section)})</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {(transaction && section) && (
                    <Row>
                        <Col md={12}>
                            <div className={"text-muted"}><i>Πληροφορίες Συναλλαγής</i></div>
                            <div className={"mt-2"} style={{width: "100%", borderRadius: "8px", border: "2px solid lightgray", padding: "10px", fontSize: "14px"}}>
                                <strong>Τραπεζικός Λογαριασμός:</strong> {transaction["erp_bank_identifier"]}<br/>
                                <strong>Περιγραφή:</strong> {transaction["erp_description"]}<br/>
                                <strong>Ποσό: </strong> {getGreekCurrencyFormat(transaction.transactionAmount)}<br/>
                                <strong>Ημερομηνία:</strong> {moment(transaction["valueDate"]).format("DD/MM/YYYY")}<br/>
                            </div>
                            {(currentUser?.userType === "Admin" && transaction?.ai_processed_by_same_transactions) && (
                                <h6 style={{textAlign: "center"}} className={"mt-2"}>Μήνυμα Admin: Η συναλλαγή δέχθηκε επεξεργασία κατόπιν πολλών ομοίων.</h6>
                            )}
                            {transaction.ai_jsonResponse && (
                                <Button size={"sm"} className={"mt-1 mr-1"} onClick={() => setShowAIJsonResponse(true)}>
                                    <LuFileJson size={16} /> Προβολή AI JSON Response
                                </Button>
                            )}
                            {transaction.ai_thoughts && (
                                <Button size={"sm"} className={"mt-1 mr-1"} onClick={() => setShowAIThoughts(true)}>
                                    <RiGeminiFill size={16} /> Προβολή Συλλογισμού AI
                                </Button>
                            )}
                            {transaction.ai_trail && (
                                <Button size={"sm"} className={"mt-1"} onClick={() => setShowTrailModal(true)}>
                                    <PiPathFill size={16} /> Προβολή AI Trail
                                </Button>
                            )}
                        </Col>
                        {multipleAIInvoices && (
                            <Col md={12} className={"mt-2"}>
                                <AIDraftLine ai_drafts={ai_drafts} onAIDraftChange={onAIDraftChange} selectedIndex={draftDocumentIndex} />
                            </Col>
                        )}
                        <Col md={12} className={"mt-2"}>
                            <div style={{
                                pointerEvents: loading ? "none" : "",
                                userSelect: loading ? "none" : "",
                                opacity: loading ? "0.7" : "",
                            }}>
                                <Accordion defaultActiveKey={documentHooks?.length > 0 ? "" : "0"}>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Καταχώρηση εγγραφής</Accordion.Header>
                                        <Accordion.Body style={{overflow: "visible !important"}}>
                                            <div>
                                                <Row>
                                                    {upgraded && (
                                                        <Col md={3}>
                                                            <Dropdown
                                                                name={"bankingSubCategory"}
                                                                label={"Υποκατηγορία τραπεζικής εγγραφής"}
                                                                options={bankingSubCategoriesOptions}
                                                                defaultValue={bankingSubCategoriesOptions.find((el) => el.value === newHook.subcategoryId)}
                                                                required={true}
                                                                onChange={(e) => {
                                                                    if (newHook.subcategoryId !== e.value) {
                                                                        setNewHook({...defaultHook, subcategoryId: e.value, subcategoryName: e.label});
                                                                        const subCat = bankingSubCategories.find((el) => el._id === e.value);
                                                                        if (subCat.section) setSection(subCat.section);
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                    )}
                                                    <Col md={3}>
                                                        <Dropdown
                                                            name={"section"}
                                                            label={"Κατηγορία εγγράφου"}
                                                            options={getSectionOptions()}
                                                            defaultValue={getSectionOptions().find((el) => el.value === section)}
                                                            disabled={upgraded}
                                                            onChange={(e) => {
                                                                if (e.value !== section) setSection(e.value);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Dropdown
                                                            name={"type"}
                                                            label={"Τύπος εγγραφής"}
                                                            options={hookOptions}
                                                            defaultValue={hookOptions.find((el) => el.value === newHook.type)}
                                                            onChange={(e) => {
                                                                if (e.value !== newHook.type) {
                                                                    if (upgraded) {
                                                                        setNewHook({...defaultHook, type: e.value, subcategoryId: newHook.subcategoryId, subcategoryName: newHook.subcategoryName});
                                                                    } else {
                                                                        setNewHook({...defaultHook, type: e.value});
                                                                    }
                                                                    if (viewData.length === 0 && e.value === "correlate") fetchViewData(false);
                                                                }
                                                            }}
                                                        />
                                                    </Col>
                                                    {renderBestDocumentAlert()}
                                                </Row>
                                                {newHook.type === "new" ? (
                                                    <React.Fragment>
                                                        {section === "Sales" ? (
                                                            <React.Fragment>
                                                                <SalesNew lockPaymentType={true} />
                                                                <div className={"text-muted mb-2"}><i>Ρυθμίσεις είσπραξης</i></div>
                                                            </React.Fragment>
                                                        ) : section === "Buys" ? (
                                                            <React.Fragment>
                                                                <BuysNew lockPaymentType={true} />
                                                                <div className={"text-muted mb-2"}><i>Ρυθμίσεις πληρωμής</i></div>
                                                            </React.Fragment>
                                                        ) : section === "Accounting Records" ? (
                                                            <React.Fragment>
                                                                <NewAccountingRecord lockPaymentType={true} />
                                                            </React.Fragment>
                                                        ) : section === "Client Payments" ? (
                                                            <React.Fragment>
                                                                <ClientPaymentsNew lockPaymentType={true} lockDocumentType={upgraded} />
                                                            </React.Fragment>
                                                        ) : section === "Supplier Payments" ? (
                                                            <React.Fragment>
                                                                <SupplierPaymentsNew lockPaymentType={true} lockDocumentType={upgraded} />
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment>
                                                                {/* Code below is deprecated, unreachable */}
                                                                <Row>
                                                                    <Col md={4}>
                                                                        <Dropdown
                                                                            name={"installation"}
                                                                            label={"Εγκατάσταση"}
                                                                            options={installationOptions}
                                                                            defaultValue={installationOptions.find((el) => el.value === newHook.installation)}
                                                                            onChange={(e) => setNewHook({...newHook, installation: e.value})}
                                                                        />
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <DateBox
                                                                            name={"date"}
                                                                            label={"Ημερομηνία"}
                                                                            selected={newHook.date ? newHook.date : null}
                                                                            onChange={(e) => {
                                                                                let val;
                                                                                if (moment(e).isValid()) {
                                                                                    val = moment(e).hour(10).toDate();
                                                                                } else {
                                                                                    val = moment().hour(10).toDate();
                                                                                }
                                                                                setNewHook({...newHook, date: val});
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Dropdown
                                                                            name={"documentType"}
                                                                            label={"Γενικό Παραστατικό"}
                                                                            options={documentTypesOptions}
                                                                            defaultValue={documentTypesOptions.find((el) => el.value === newHook.documentType)}
                                                                            onChange={(e) => setNewHook({...newHook, documentType: e.value})}
                                                                        />
                                                                    </Col>
                                                                    <Col md={2}>
                                                                        <Dropdown
                                                                            name={"preNumber"}
                                                                            label={"Σειρά"}
                                                                            options={preNumberOptions}
                                                                            defaultValue={preNumberOptions.find((el) => el.value === newHook.preNumber)}
                                                                            onChange={(e) => setNewHook({...newHook, preNumber: e.value})}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={8}>
                                                                        <AdvancedCombobox
                                                                            name="correlatedEntity"
                                                                            className="w-100 ac-select-dropdown"
                                                                            defaultValue={newHook.correlatedEntityName}
                                                                            label={"Συσχετιζόμενη οντότητα"}
                                                                            data={correlatedEntitiesList}
                                                                            key={newHook.correlatedEntity}
                                                                            onChange={(e) => {
                                                                                setNewHook({...newHook, correlatedEntity: e.row._id, correlatedEntityName: e.row.name})
                                                                            }}
                                                                            resetFilter={() => setNewHook({...newHook, correlatedEntity: "", correlatedEntityName: ""})}
                                                                            onChangeSearch={loadCorrelatedEntitiesList}
                                                                            excludeColumns={[]}
                                                                            columns={[
                                                                                {label: "Όνομα", name: "name"},
                                                                                {label: "ΑΦΜ", name: "vatNumber"},
                                                                                {label: "Τηλέφωνο", name: "phone"},
                                                                            ]}
                                                                            deleteEnable={false}
                                                                            searchTableEnable={false}
                                                                            showTableOptionOnSelect={true}
                                                                            placeholder={"Εισάγετε συσχετιζόμενη οντότητα"}
                                                                            required={true}
                                                                            showInsertAddButton={true}
                                                                            hideSaveButton={true}
                                                                            hideInsertNewRow={true}
                                                                            inputFieldClasses="form-control"
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <label>Ποσό</label>
                                                                        <AccountingBox
                                                                            name={"amount"}
                                                                            key={newHook.amount}
                                                                            defaultValue={newHook.amount}
                                                                            onBlur={(e) => {
                                                                                let val = +e.target.value;
                                                                                if (val) {
                                                                                    val = Math.abs(+Number(val).toFixed(2));
                                                                                    setNewHook({...newHook, amount: val});
                                                                                } else {
                                                                                    setNewHook({...newHook, amount: 0});
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row className={"mb-2"}>
                                                                    <Col md={12}>
                                                                        <Input
                                                                            name={"reason"}
                                                                            label={"Αιτιολογία"}
                                                                            value={newHook.reason}
                                                                            onChange={(e) => setNewHook({...newHook, reason: e.target.value})}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        )}
                                                        {["Sales", "Buys"].includes(section) && (
                                                            <React.Fragment>
                                                                <Row>
                                                                    <Col md={3}>
                                                                        <DateBox
                                                                            name={"autopaymentDate"}
                                                                            label={"Ημερομηνία"}
                                                                            selected={newHookAutoPayment.date}
                                                                            onChange={(e) =>  {
                                                                                let val;
                                                                                if (moment(e).isValid()) {
                                                                                    val = moment(e).hour(10).toDate();
                                                                                } else {
                                                                                    val = moment().hour(10).toDate();
                                                                                }
                                                                                setNewHookAutoPayment({...newHookAutoPayment, date: val});
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Dropdown
                                                                            name={"documentType"}
                                                                            label={"Γενικό Παραστατικό"}
                                                                            options={autoPaymentDocumentTypes}
                                                                            defaultValue={autoPaymentDocumentTypes.find((el) => el.value === newHookAutoPayment.documentType)}
                                                                            onChange={(e) => setNewHookAutoPayment({...newHookAutoPayment, documentType: e.value})}
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Dropdown
                                                                            name={"preNumber"}
                                                                            label={"Σειρά"}
                                                                            options={autoPaymentPreNumbers}
                                                                            defaultValue={autoPaymentPreNumbers.find((el) => el.value === newHookAutoPayment.preNumber)}
                                                                            onChange={(e) => setNewHookAutoPayment({...newHookAutoPayment, preNumber: e.value})}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                ) : newHook.type === "correlate" ? (
                                                    <React.Fragment>
                                                        <div className={"text-muted"}><i>Φίλτρα</i></div>
                                                        <Row>
                                                            <Col md={3}>
                                                                <DateHelper
                                                                    dateFromAndToFunction={(from, to) => setRequestData({...requestData, dateFrom: from, dateTo: to})}
                                                                />
                                                            </Col>
                                                            <Col md={2}>
                                                                <DateBox
                                                                    name={"dateFrom"}
                                                                    label={"Ημερομηνία από"}
                                                                    selected={moment(requestData.dateFrom, "DD/MM/YYYY").isValid() ? moment(requestData.dateFrom, "DD/MM/YYYY").toDate() : null}
                                                                    onChange={(e) => {
                                                                        if (moment(e).isValid()) {
                                                                            setRequestData({...requestData, dateFrom: moment(e).format("DD/MM/YYYY")});
                                                                        } else {
                                                                            setRequestData({...requestData, dateFrom: moment().format("DD/MM/YYYY")});
                                                                        }
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col md={2}>
                                                                <DateBox
                                                                    name={"dateTo"}
                                                                    label={"Ημερομηνία έως"}
                                                                    selected={moment(requestData.dateTo, "DD/MM/YYYY").isValid() ? moment(requestData.dateTo, "DD/MM/YYYY").toDate() : null}
                                                                    onChange={(e) => {
                                                                        if (moment(e).isValid()) {
                                                                            setRequestData({...requestData, dateTo: moment(e).format("DD/MM/YYYY")});
                                                                        } else {
                                                                            setRequestData({...requestData, dateTo: moment().format("DD/MM/YYYY")});
                                                                        }
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col md={5}>
                                                                <Input
                                                                    name={"generalFilter"}
                                                                    label={"Φίλτρο"}
                                                                    value={requestData.generalFilter}
                                                                    onChange={(e) => setRequestData({...requestData, generalFilter: e.target.value})}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className={"mt-1"}>
                                                            <Col md={3}>
                                                                <Input
                                                                    name={"entity"}
                                                                    label={"Αντισυμβαλλόμενος"}
                                                                    type={"text"}
                                                                    onChange={(e) => setRequestData({...requestData, entity: e.target.value})}
                                                                />
                                                            </Col>
                                                            <Col md={2}>
                                                                <Input
                                                                    name={"amount_from"}
                                                                    label={"Ποσό από"}
                                                                    type={"number"}
                                                                    onChange={(e) => setRequestData({...requestData, amount_from: e.target.value})}
                                                                />
                                                            </Col>
                                                            <Col md={2}>
                                                                <Input
                                                                    name={"amount_to"}
                                                                    label={"Ποσό έως"}
                                                                    type={"number"}
                                                                    onChange={(e) => setRequestData({...requestData, amount_to: e.target.value})}
                                                                />
                                                            </Col>
                                                            <Col md={5} className={"d-flex justify-content-end"}>
                                                                <Button style={{marginTop: "25px"}} onClick={() => fetchViewData(false)}>Εφαρμογή φίλτρων</Button>
                                                            </Col>
                                                        </Row>
                                                        {totalPages > 0 && (
                                                            <React.Fragment>
                                                                <div className="d-flex justify-content-end mb-2 mt-2">
                                                                    <Pagination
                                                                        currentPage={page}
                                                                        totalPages={totalPages}
                                                                        handlePageChange={handlePageChange}
                                                                    />
                                                                </div>
                                                                {viewData.length > 0 ? (
                                                                    <table className={"simpleClassicTable"} style={{wordBreak: "break-all"}}>
                                                                        <colgroup>
                                                                            <col span={1} style={{width: "10%"}}></col>
                                                                            <col span={1} style={{width: "30%"}}></col>
                                                                            <col span={1} style={{width: "25%"}}></col>
                                                                            <col span={1} style={{width: "10%"}}></col>
                                                                            <col span={1} style={{width: "25%"}}></col>
                                                                        </colgroup>
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Ημερομηνία</th>
                                                                            <th>Στοιχεία εγγράφου</th>
                                                                            <th>Αντισυμβαλλόμενος</th>
                                                                            <th>Ποσό</th>
                                                                            <th>Ενέργειες</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {viewData.map((row, idx) => (
                                                                            <tr key={`ertable-${idx}`}
                                                                                style={{backgroundColor: isSelected(row._id) ? "lightgray" : ""}}>
                                                                                <td>{moment(row["date"]).format("DD/MM/YYYY")}</td>
                                                                                <td>{getDocumentLabel(row)}</td>
                                                                                <td>{getEntity(row)}</td>
                                                                                <td>{getGreekCurrencyFormat(row["paymentAmount"] || row["sum"] || row["amount"])}</td>
                                                                                <td>{renderSelectionTD(row)}</td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                    </table>
                                                                ) : (
                                                                    <span>Δεν βρέθηκαν δεδομένα</span>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment></React.Fragment>
                                                )}
                                                {newHook.type === "new" && (
                                                    <React.Fragment>
                                                        {availableNewLoan && (
                                                            <Accordion defaultActiveKey="0" className={"mb-2"}>
                                                                <Accordion.Item eventKey="0">
                                                                    <Accordion.Header>Δεδομένα δανείου</Accordion.Header>
                                                                    <Accordion.Body>
                                                                        <NewLoan bankingLockFields={true} />
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        )}
                                                        {!multipleAIInvoices && (
                                                            <Row>
                                                                <Col md={5} className={"d-flex justify-content-start"}>
                                                                    {(upgraded && transaction?.ai_status === 500) && (
                                                                        <React.Fragment>{renderAIActionButtons()}</React.Fragment>
                                                                    )}
                                                                </Col>
                                                                <Col md={7} className={"d-flex justify-content-end"}>
                                                                    {section === "Sales" && (
                                                                        <div className={"mt-2 mr-2"}>
                                                                            Κατά την καταχώρηση της πώλησης, γίνεται συσχέτιση με την είσπραξή της και όχι με την πώληση την ίδια.
                                                                        </div>
                                                                    )}
                                                                    {section === "Buys" && (
                                                                        <div className={"mt-2 mr-2"}>
                                                                            Κατά την καταχώρηση της αγοράς, γίνεται συσχέτιση με την πληρωμή της και όχι με την αγορά την ίδια.
                                                                        </div>
                                                                    )}
                                                                    {(!upgraded || (upgraded && ai_drafts.length === 0)) && (
                                                                        <Button variant="primary" onClick={() => onHookSave(false)} disabled={loading}>
                                                                            {["Sales", "Buys"].includes(section) ? "Καταχώρηση & Συσχέτιση" : "Καταχώρηση"}
                                                                            {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                                                        </Button>
                                                                    )}
                                                                    {upgraded && (
                                                                        <Button variant="primary" className={"ml-1"} style={{fontWeight: "700"}} onClick={() => onHookSave(true)} disabled={loading}>
                                                                            Καταχώρηση & Αποθήκευση
                                                                            {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                {multipleAIInvoices && (
                                    <Row className={"mt-3"}>
                                        <Col md={5} className={"d-flex justify-content-start"}>
                                            {(upgraded && transaction?.ai_status === 500) && (
                                                <React.Fragment>{renderAIActionButtons()}</React.Fragment>
                                            )}
                                        </Col>
                                        <Col md={7} className={"d-flex justify-content-end"}>
                                            <Button variant="primary" style={{fontWeight: "700"}} onClick={() => onMultipleAISave()} disabled={loading}>
                                                Καταχώρηση ΟΛΩΝ & Αποθήκευση
                                                {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        </Col>
                        <Col md={12} className={"mt-2"}>
                            <div className={"text-muted mt-2 mb-1"}><i>Συσχετιζόμενες εγγραφές</i></div>
                            {documentHooks?.length === 0 && (
                                <div style={{textAlign: "center", fontSize: "16px"}} className={"mt-3"}>Δεν υπάρχουν συσχετιζόμενες εγγραφές</div>
                            )}
                            {documentHooks?.length >= 2 && (
                                <div>
                                    <Button size={"sm"} variant={"outline-danger"} onClick={() => {
                                        setShowDeleteDecorrelateModal(true);
                                    }}>Προς Aποσυσχέτιση & Διαγραφή όλων</Button>

                                    <DeleteDecorrelateModal
                                        show={showDeleteDecorrelateModal}
                                        setShow={setShowDeleteDecorrelateModal}
                                        selectedTransactions={[transaction]}
                                        successCallback={() => {
                                            refreshTransaction();
                                        }}
                                    />
                                </div>
                            )}
                            <Row>
                                {documentHooks?.length > 0 && documentHooks.map((doc, idx) => (
                                    <Col md={4}>
                                        <div className={"mt-2"} style={{
                                            position: "relative",
                                            width: "100%",
                                            borderRadius: "8px",
                                            border: `2px solid ${doc.type === "new" ? "green" : "blue"}`,
                                            padding: "10px",
                                            fontSize: "16px"
                                        }} key={`docHook-${idx}`}>
                                            <strong>Τύπος: </strong> {sectionTitle(doc.section)}<br/>
                                            {doc.correlatedEntityName && (
                                                <React.Fragment>
                                                    <strong>Συσχετιζόμενη οντότητα:</strong> {doc.correlatedEntityName}<br/>
                                                </React.Fragment>
                                            )}
                                            {doc?.label && (
                                                <React.Fragment><strong>Παραστατικό: </strong> {String(doc.label).replace(/undefined/g, "")}<br/></React.Fragment>
                                            )}
                                            <strong>Ποσό: </strong> {getGreekCurrencyFormat(doc.amount)}<br/>
                                            <strong>Πρόσημο: {doc.affects}</strong>
                                            {/*
                                            <select name={`affection_select_${idx}`}
                                                    key={doc.affects}
                                                    defaultValue={doc.affects}
                                                    onChange={(e) => {
                                                        const clone = structuredClone(documentHooks);
                                                        clone[idx].affects = e.target.value;
                                                        setDocumentHooks(clone);
                                                    }}
                                            >
                                                <option value={"No"}>Κενό</option>
                                                <option value={"+"}>+</option>
                                                <option value={"-"}>-</option>
                                            </select>
                                            */}
                                            <br/>
                                            <div style={{textAlign: "center"}} className={"mt-1"}>
                                                <Popconfirm
                                                    title={doc.type === "new" ? "Αφαίρεση εγγραφής" : "Αποσυσχέτιση εγγραφής"}
                                                    description={doc.type === "new" ? "Είσαστε σίγουροι ότι θέλετε να αφαιρέσετε αυτήν την εγγραφή;" : "Είσαστε σίγουροι ότι θέλετε να αποσυσχετίσετε την παρούσα εγγραφή;"}
                                                    onConfirm={() => {
                                                        const cloneHooks = documentHooks.slice();
                                                        cloneHooks.splice(idx, 1);
                                                        setDocumentHooks(cloneHooks);
                                                    }}
                                                    okText={"Ναι"}
                                                    cancelText={"Όχι"}
                                                >
                                                    <Button size={"sm"} style={{backgroundColor: '#fed713', color: "black"}} variant={"outline-warning"}>
                                                        <TfiUnlink size={14} className={"mr-2"} />{doc.type === "new" ? "Αφαίρεση" : "Αποσυσχέτιση"}
                                                    </Button>
                                                </Popconfirm>
                                                {doc.type === "correlate" && (
                                                    <React.Fragment>
                                                        <Button size={"sm"} variant={"outline-danger"} className={"ml-2"} onClick={() => {
                                                            setToBeDeleted(doc.documentId);
                                                            setToBeDeletedSection(doc.section);
                                                            setShowDeleteModal(true);
                                                        }}>
                                                            <CiTrash size={14} className={"mr-2"} />Αποσυσχέτιση & Διαγραφή
                                                        </Button>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                            <div className={"mb-3"}></div>
                                            <div style={{
                                                position: "absolute",
                                                right: "0",
                                                bottom: "0",
                                                backgroundColor: doc.type === "new" ? "green" : "blue",
                                                overflow: "hidden",
                                                color: "white",
                                                borderTopLeftRadius: "8px",
                                                fontSize: "12px",
                                            }}>
                                                <div className={"p-1"}>
                                                    {doc.type === "new" ? "Νέα εγγραφή" : (
                                                        <React.Fragment>
                                                            <div onClick={() => handleOpenCorrelated(doc.documentId, doc.section)} style={{cursor: "pointer"}}>Συσχετιζόμενη εγγραφή</div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                )}
                {!!transaction?.ai_sibling_notification && (
                    <Alert variant={"danger"} className={"mt-3"}>
                        <strong>Προσοχή!</strong> Έχει εντοπιστεί η ενδοεταιρική συναλλαγή και κατά την αποθήκευση θα διαγραφούν
                        οι εγγραφές της άλλης συναλλαγής και θα αντικατασταθούν με την εγγραφή της ενδοεταιρικής μεταφοράς που θα δημιουργήσετε.
                    </Alert>
                )}
                </Modal.Body>
                <Modal.Footer>
                    <div style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: currentSum > maxSum ? "red" : currentSum === maxSum ? "green" : "",
                        textDecoration: currentSum > maxSum ? "underline" : "",
                        textAlign: "center"
                    }}>
                        Άθροισμα Εγγραφών / Ποσό συναλλαγής<br/> {getGreekCurrencyFormat(currentSum)} / {getGreekCurrencyFormat(maxSum)}
                    </div>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onSave()} disabled={loading}>
                        Αποθήκευση {loading && <Spinner className={"ml-2"} animation="border" variant="light" />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <DeleteModal
                showDelete={showDeleteModal}
                showDeleteModal={setShowDeleteModal}
                toBeDeleted={toBeDeleted}
                tableName={sectionToTableName[toBeDeletedSection]}
                updateFunction={() => {
                    handleDeselect(toBeDeleted);
                    if (viewData.length > 0) fetchViewData(true);
                    callback();
                }}
            />

            <Modal show={showTrailModal} onHide={() => setShowTrailModal(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Πορεία AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AITrailViewer ai_trail={transaction?.ai_trail || null} />
                </Modal.Body>
            </Modal>

            <Modal show={showAIJsonResponse} onHide={() => setShowAIJsonResponse(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>AI JSON Response</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {transaction?.ai_jsonResponse && (
                        <pre>
                            {JSON.stringify(transaction.ai_jsonResponse, null, 2)}
                        </pre>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showAIThoughts} onHide={() => setShowAIThoughts(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Συλλογισμός AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {transaction?.ai_thoughts && (
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {transaction.ai_thoughts}
                        </pre>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showReprocess} onHide={() => setShowReprocess(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Επανεπεξεργασία συναλλαγής από Primer AI</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να στείλετε αίτημα επανεπεξεργασίας στο Primer AI της παρούσας συναλλαγής;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowReprocess(false)}>
                        Όχι, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShow(false);
                        setShowReprocess(false);
                        if (onAIReprocess) onAIReprocess(transaction);
                    }}>
                        Ναι, επανεπεξεργασία
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDecline} onHide={() => setShowDecline(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Απόρριψη αποτελέσματος συναλλαγής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να απορρίψετε το αποτέλεσμα από το Primer AI της παρούσας συναλλαγής;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowDecline(false)}>
                        Όχι, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShow(false);
                        setShowDecline(false);
                        if (onAIDecline) onAIDecline(transaction);
                    }}>
                        Ναι, απόρριψη
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default HookTransactionModal;
